export enum CognitoStatus {
  'unconfirmed' = 'UNCONFIRMED',
  'confirmed' = 'CONFIRMED',
  'archived' = 'ARCHIVED',
  'compromised' = 'COMPROMISED',
  'unknown' = 'UNKNOWN',
  'resetRequired' = 'RESET_REQUIRED',
  'forceChangePw' = 'FORCE_CHANGE_PASSWORD',
}
